<template>
  <span v-if="description" class="custom-field__help">
    <v-tooltip location="top">
      <template #activator="{ props }">
        <v-icon v-bind="props" size="small">mdi-help-circle</v-icon>
      </template>
      <span>{{ description }}</span>
    </v-tooltip>
  </span>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CustomFieldDescriptionHelper',
  props: {
    description: {
      type: [String, null, undefined],
      required: false
    }
  }
});
</script>
